module.exports = __webpack_public_path__ + "static/media/id_logo.23226aac.png";